import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import MobileBar from './MobileBar';

export default function Layout() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const target = hash && document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return (
    <div className="app">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
